const STORAGE_KEY = 'hawk_login_email_history';
const MAX_ITEMS = 30;

export function loadLoginEmailHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.filter((e) => typeof e === 'string' && e.includes('@'));
  } catch {
    return [];
  }
}

export function rememberLoginEmail(email) {
  const normalized = (email || '').trim().toLowerCase();
  if (!normalized || !normalized.includes('@')) return;
  const prev = loadLoginEmailHistory().filter(
    (e) => e.toLowerCase() !== normalized
  );
  const next = [normalized, ...prev].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function filterLoginEmailHistory(history, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return history;
  return history.filter((e) => e.toLowerCase().includes(q));
}
